// CSV generation for the chat answer's full result table. Pure `toCsv`
// (RFC 4180) is unit-tested; `downloadCsv` is a thin DOM side-effect covered
// by the chat e2e. Modeled on fmsSqlFormat.ts (pure page-level util module).

type Cell = string | number | boolean | null;

// RFC 4180: quote a field containing a comma, double-quote, CR, or LF; escape
// embedded double-quotes by doubling them. null renders as an empty field.
const escapeField = (value: Cell): string => {
    if (value === null) {
        return "";
    }
    const s = String(value);
    if (/[",\r\n]/.test(s)) {
        return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
};

export function toCsv(columns: string[], rows: Cell[][]): string {
    const lines = [columns.map(escapeField).join(",")];
    for (const row of rows) {
        lines.push(row.map(escapeField).join(","));
    }
    return lines.join("\r\n");
}

// Trigger a browser download of `csv` as `filename`. Prefixes a UTF-8 BOM
// (U+FEFF) so Excel reads non-ASCII correctly. Not unit-tested (jsdom lacks
// createObjectURL); the chat e2e exercises it end to end.
export function downloadCsv(filename: string, csv: string): void {
    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
